import axios from 'axios';
import { configureHttpHeaders, onSuccess, onError } from '../api/apiHelpers';
import { getTokenizeBaseUrl } from '../api/getTokenizeBaseUrl';

const TOKENIZATION_API = getTokenizeBaseUrl();

export function getToken(cardNumber) {
  configureHttpHeaders(axios);
  const url = `api/v1/tokenize`;
  let isArray = Array.isArray(cardNumber);
  if (isArray) {
    cardNumber = cardNumber.toString();
  }
  const data = {
    accountNumber: cardNumber,
  };
  return post(url, data);
}

function post(postUrl, postData) {
    return axios({
      method: 'post',
      url: `${TOKENIZATION_API}${postUrl}`,
      data: postData,
    })
      .then(onSuccess)
      .catch(onError);
  }

export default {
  getToken,
};
